import { FC, ReactNode, useEffect, useState } from 'react'
import styled from 'styled-components/macro'
import { AnimatePresence, motion, easeInOut } from 'framer-motion'

import { ReadMore } from './read-more'
import { Cover, CoverImage, StyledDetails, Toggle } from './styled'
import { TextContainer } from 'components/container'

type Props = {
  children: ReactNode | ReactNode[]
  className?: string
  onToggle?: (isOpen: boolean) => void
  posterImage?: string
}

const DetailsComp: FC<Props> = ({
  children,
  className = '',
  posterImage,
  onToggle,
}) => {
  const [isOpen, setOpen] = useState(false)

  useEffect(() => {
    if (onToggle) {
      onToggle(isOpen)
    }
  }, [isOpen])

  return (
    <StyledDetails className={className}>
      <TextContainer>
        <Cover
          animate={{
            marginBottom: isOpen ? '3rem' : 0,
          }}
          transition={{ delay: !isOpen ? 0.3 : 0 }}
        >
          <CoverImage
            src={posterImage}
            animate={{
              marginBottom: isOpen ? '0%' : '-15%',
            }}
            transition={{ delay: !isOpen ? 0.3 : 0 }}
            alt=""
          />
        </Cover>
      </TextContainer>
      <Toggle>
        <ReadMore onClick={() => setOpen(v => !v)}>
          {isOpen ? 'Свернуть' : 'Читать дальше'}
        </ReadMore>
      </Toggle>
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            exit={{
              height: 0,
              opacity: 0,
              transition: {
                height: {
                  type: 'tween',
                  duration: 0.3,
                  delay: 0.3,
                  ease: easeInOut,
                },
              },
            }}
            animate={{
              height: 'auto',
              opacity: 1,
            }}
          >
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </StyledDetails>
  )
}

export const Details = styled(DetailsComp)``
